import styled from 'styled-components';
export default styled.button`
  padding: 15px;
  background-color: white;
  color: #585858;
  font-size: 12px;
  font-weight: 500;
  border: 1px solid #f5f5f5;
  cursor: pointer;
  min-width: 200px;
  max-width: 200px;
  text-align: left;

  &:hover:not(:disabled) {
    background-color: #eaeaea;
  }

  &:disabled {
    cursor: no-drop;
    opacity: 0.5;
  }
`;

